import { checkForInvalidVariables } from '@/utils/commonHelpers';

/**
 * Validates if required email fields are present
 */
export const validateEmailFields = (
  from: any,
  subject: string,
  body: string,
  showToast: (_message: { title: string; status?: string }) => any,
  surveyType?: string,
  isInterviewPlan?: boolean
): boolean => {
  const fields = [
    { value: subject, name: 'Subject' },
    { value: body, name: 'Body' },
  ];

  // 'From' is mandatory when NOT in interview plan (i.e., when sending survey from job stage)
  if (!isInterviewPlan && !from) {
    showToast({ title: 'From is mandatory', status: 'error' });
    return false;
  }

  const hasError = fields.some((field) => {
    if (!field.value) {
      showToast({ title: `${field.name} is mandatory`, status: 'error' });
      return true;
    }
    return false;
  });

  return !hasError;
};

/**
 * Validates variables in subject and body
 */
export const validateVariables = (
  subject: string,
  body: string,
  variablesListArr: string[],
  showToast: (_message: { title: string; status?: string }) => void
): boolean => {
  // Check if survey.link is present in body
  const hasSurveyLink = /{{\s*survey\.link\s*}}/g.test(body);
  if (!hasSurveyLink) {
    const element = document.querySelector(`#invalid-variables-alert`);
    element?.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });
    showToast({ title: `{{survey.link}} is mandatory`, status: 'error' });
    return false;
  }

  // For subject: remove sender.email_signature from variables array
  const subjectVariablesListArr = variablesListArr.filter(
    (variable) => variable !== 'sender.email_signature'
  );

  //  invalid variables - subject
  const hasInvalidVariablesInSubject = checkForInvalidVariables({
    variablesListArr: subjectVariablesListArr,
    content: subject,
  });

  //  invalid variables - body
  const hasInvalidVariablesInBody = checkForInvalidVariables({
    variablesListArr,
    content: body,
  });

  const isInvalidVariablesFound =
    hasInvalidVariablesInSubject || hasInvalidVariablesInBody;

  if (isInvalidVariablesFound) {
    const element = document.querySelector(`#invalid-variables-alert`);
    element?.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });
    return false;
  }

  return true;
};

/**
 * Builds the from payload based on feature flags
 */
export const getFromPayload = (
  from: any,
  fromUserObject: any,
  feSharedEmails: boolean,
  processFromUserPayload: (_params: any) => any
) => {
  if (feSharedEmails) {
    return processFromUserPayload({
      selectedUser: fromUserObject,
      payloadKey: 'from',
    });
  }
  return { senderId: from };
};

/**
 * Validates to for HM surveys
 */
export const validateToAddress = (
  surveyType: string,
  toAddress: string | string[] | undefined,
  showToast: (_message: { title: string; status?: string }) => void,
  isInterviewPlan?: boolean
): boolean => {
  // Skip validation for candidate surveys - email is automatically sent to candidate
  if (surveyType === 'candidate') {
    return true;
  }
  const isEmpty =
    !toAddress || (Array.isArray(toAddress) && toAddress?.length === 0);

  // 'To' is mandatory when NOT in interview plan (i.e., when sending survey from job stage)
  if (!isInterviewPlan && isEmpty) {
    showToast({ title: 'To is mandatory', status: 'error' });
    return false;
  }
  return true;
};

/**
 * Scrolls to invalid variables alert
 */
export const scrollToInvalidVariables = () => {
  const element = document.querySelector(`#invalid-variables-alert`);
  element?.scrollIntoView({
    behavior: 'smooth',
    block: 'center',
  });
};
